/**
 * meetingsApi.js
 * All meetings API calls — uses authFetchJSON which handles
 * token refresh + auto-logout on expired sessions.
 */
import { BASE_URL } from "../config";
import { authFetchJSON } from "../utils/apiClient";

const BASE = `${BASE_URL}api/meetings`;

// ── Google Calendar ────────────────────────────────────────────────
export const getGoogleStatus  = () => authFetchJSON(`${BASE}/google/status/`);
export const getGoogleAuthUrl = () => authFetchJSON(`${BASE}/google/auth/`);
export const disconnectGoogle = () => authFetchJSON(`${BASE}/google/disconnect/`, { method: "DELETE" });

// ── Availability ───────────────────────────────────────────────────
export const getAvailability    = ()     => authFetchJSON(`${BASE}/availability/`);
export const updateAvailability = (data) => authFetchJSON(`${BASE}/availability/`, {
  method: "PUT",
  body: JSON.stringify(data),
});

// ── Meeting Types ──────────────────────────────────────────────────
export const getMeetingTypes   = ()          => authFetchJSON(`${BASE}/types/`);
export const createMeetingType = (data)      => authFetchJSON(`${BASE}/types/`, {
  method: "POST",
  body: JSON.stringify(data),
});
export const updateMeetingType = (id, data)  => authFetchJSON(`${BASE}/types/${id}/`, {
  method: "PUT",
  body: JSON.stringify(data),
});
export const deleteMeetingType = (id)        => authFetchJSON(`${BASE}/types/${id}/`, {
  method: "DELETE",
});

// ── Bookings ───────────────────────────────────────────────────────
export const getBookings    = (bookingStatus = "confirmed") =>
  authFetchJSON(`${BASE}/bookings/?status=${bookingStatus}`);

export const cancelBooking  = (id) =>
  authFetchJSON(`${BASE}/bookings/${id}/cancel/`, { method: "POST" });

// ── Public (no auth — plain fetch) ────────────────────────────────
async function publicFetch(url) {
  const res = await fetch(url);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || "Request failed");
  return data;
}

export const getPublicMeetingType = (slug) =>
  publicFetch(`${BASE_URL}api/meetings/public/${slug}/`);

export const getPublicSlots = (slug, date) =>
  publicFetch(`${BASE_URL}api/meetings/public/${slug}/slots/?date=${date}`);

export const getPublicMonthAvailability = (slug, year, month) =>
  publicFetch(`${BASE_URL}api/meetings/public/${slug}/month-availability/?year=${year}&month=${month}`);

export const createPublicBooking = (slug, data) =>
  fetch(`${BASE_URL}api/meetings/public/${slug}/book/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  }).then(r => r.json());
